import ViewInArIcon from '@mui/icons-material/ViewInAr';
import { ActionButton } from '../types';

const getBulkImportSolidsSceneActions = (): ActionButton[] => [
  {
    value: 'show stope shapes',
    ariaLabel: 'show stope shapes',
    tooltip: 'Show Stope Shapes',
    icon: <ViewInArIcon />,
    selected: (model) => model.showStopeShapes,
    onClick: (model) => model.setShowStopeShapes(!model.showStopeShapes),
    group: 'stope-shapes',
  },
];

export default getBulkImportSolidsSceneActions;
